<template>
  <component-wrapper>
    <grid-container-fi
      :class="{
        'contact-fi': true,
        'contact-fi--dark': fields.darkBackground?.value,
      }"
      grid-class="contact-fi__content"
    >
      <div
        class="fi-col-start-1 fi-col-end-13 md:fi-col-start-2 md:fi-col-end-7 lg:fi-col-end-6 xl:fi-col-start-3 xl:fi-col-end-7"
      >
        <div class="contact-fi__headline">
          <headline-fi
            v-if="(isEditMode && fields.subheadline) || fields.subheadline?.value"
            class="fi-mb-12"
            tag="div"
            color="brand"
            :size="30"
            :html-content="isEditMode ? fields.subheadline.editable : fields.subheadline?.value"
          />
          <headline-fi
            v-if="(isEditMode && fields.headline) || fields.headline?.value"
            tag="h3"
            :size="60"
            :html-content="isEditMode ? fields.headline.editable : fields.headline?.value"
          />
        </div>
      </div>
      <div class="fi-col-start-1 fi-col-end-13 md:fi-col-start-8 lg:fi-col-end-11">
        <div class="contact-fi__contact-details">
          <!-- eslint-disable vue/no-v-html -->
          <div
            v-if="
              (isEditMode && fields.contactDetailsHeadline) || fields.contactDetailsHeadline?.value
            "
            class="contact-fi__contact-details-head contact-fi__detail-line"
            v-html="
              isEditMode
                ? fields.contactDetailsHeadline.editable
                : fields.contactDetailsHeadline?.value
            "
          />
          <!-- eslint-enable vue/no-v-html -->
          <contact-details-fi
            :phonenumber1="fields.phonenumber1"
            :phonenumber2="fields.phonenumber2"
            :fax="fields.fax"
            :email="fields.email"
          />
        </div>
      </div>
    </grid-container-fi>
  </component-wrapper>
</template>

<script>
import { HeadlineFi } from 'atoms';

import ComponentWrapper from '@/components/component-wrapper/ComponentWrapper.vue';
import ContactDetailsFi from '@/components/contact-details-fi/ContactDetailsFi.vue';
import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';

export default {
  name: 'ContactFi',
  components: {
    ComponentWrapper,
    GridContainerFi,
    HeadlineFi,
    ContactDetailsFi,
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style scoped src="./contact-fi" />

<style src="./contact-fi-unscoped" />
